import React from 'react'
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player/youtube'
import LogoAandG from '../../assets/Elie4444.png'


const CardVideo3 = () => {
    const { t } = useTranslation();
    return (
        <div className="card mb-3 col-12 shadow-lg ">
            <div className="row no-gutters">

                <div className="col-md-4">
                    <div className="card-body">

                        <h5 className="card-title">{t('CardVideo.Interview')} Rene Daniel</h5>

                        <p className="card-text mt-5">
                            {t('CardVideo.SiteDeLartiste')} : <a href="https://www.daniel-rene.fr/" className="mt-5">www.daniel-rene.fr</a>   
                        </p>
                        
                        <div className="fixed-bottom position-absolute m-4">
                            <p className="card-text"><small className="text-muted">{t('CardVideo.MiseEnLigneLe')} 19/11/2020</small></p>
                        </div>
                        
                        <div className="text-center ">
                            <img width="60%" className="" src={LogoAandG} alt="logo facebook"/>
                        </div>
                        
                    </div>
                </div>

                <div className="col-md-8 embed-responsive embed-responsive-16by9">
                    <ReactPlayer
                    title="Interview3"
                    className='react-player embed-responsive-item'
                    url='https://www.youtube.com/embed/TwtNBjkn02g'
                    width='650'
                    height='315'
                    />
                </div>

            </div>
        </div>
    )
}

export default CardVideo3


// style={{maxWidth: "540px"}}
